import { TimeFilter } from '@/types';

export const formatLeaderboardCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const getAvatarGradient = (address: string, id?: string, index?: number): string => {
  const seed = address || id || String(index || 0).padStart(10, '0');
  return `linear-gradient(135deg, #${seed.slice(2, 8).padEnd(6, '0')} 0%, #${seed.slice(-6).padStart(6, '0')} 100%)`;
};

export const getBiggestWinsTitle = (filter: TimeFilter, t: any): string => {
  switch (filter) {
    case 'DAY':
      return t('leaderboard.biggestWinsToday');
    case 'WEEK':
      return t('leaderboard.biggestWinsWeek');
    case 'MONTH':
      return t('leaderboard.biggestWinsMonth');
    case 'ALL':
      return t('leaderboard.biggestWinsAllTime');
    default:
      return t('leaderboard.biggestWinsToday');
  }
};

export const formatTimePeriodDisplay = (tp: string, t: any) => {
  switch (tp) {
    case 'DAY':
      return t('leaderboard.today');
    case 'WEEK':
      return t('leaderboard.weekly');
    case 'MONTH':
      return t('leaderboard.monthly');
    case 'ALL':
      return t('leaderboard.all');
    default:
      return tp.charAt(0).toUpperCase() + tp.slice(1).toLowerCase();
  }
};

export const formatCategoryDisplay = (cat: string, t: any) => {
  if (!cat) return '';
  if (cat === 'OVERALL') return t('leaderboard.allCategories');

  const key = cat.toLowerCase();
  const fallback = cat.charAt(0).toUpperCase() + cat.slice(1).toLowerCase();

  return t(`categories.${key}`, { defaultValue: fallback });
};
